// extracted by mini-css-extract-plugin
module.exports = {"MadeEasySection":"MadeEasyBlock_MadeEasySection__3jd5i","MadeEasySectionWrap":"MadeEasyBlock_MadeEasySectionWrap__NhuZ4"};